import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Layout from '../../components/Layout/Layout';
// import classes from './CollectionDetails.css';
// import BSMLogo from '../../assets/logos/benito-santos-mexico.svg';
// import BSNoviasLogo from '../../assets/logos/benito-santos-novias.svg';
import SectionHeader from '../../components/SectionHeader/SectionHeader';
import * as menuActions from '../../actions/MenuActions';
import * as collectionsActions from '../../actions/CollectionsActions';
import * as categoriesActions from '../../actions/CategoriesActions';
import { Helmet } from 'react-helmet';
import BSGrid from '../../components/BSGrid/BSGrid';
import Aux from '../../hoc/Aux';

const styles = {
    loadingMessage: {
        position: 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }
};

class CollectionDetails extends Component {
    constructor(props) {
        super(props);
        this.config();
    }

    componentDidUpdate(nextProps) {
        if (nextProps.match !== this.props.match) {
            this.config();
        }
    }

    config = () => {
        const { params } = this.props.match;
        const { cat } = params;
        const { compoundId } = this.props.match.params;

        this.props.getCategory(cat);

        this.props.hideAllMenus().then(() => {
            this.props.showTopMenu();

            switch (cat) {
                case 'tailormade':
                    this.props.showTailormadeMenu();
                    break;
                case 'novias':
                    this.props.showBridesMenu();
                    break;
                case 'bs':
                    this.props.showBSMenu();
                    break;
                default:
                    break;
            }
        });

        this.props.getCollection(compoundId.match(/^([0-9a-f]+)-?/)[1]);
    };

    render() {
        const { collection } = this.props.collections;
        const { category } = this.props.categories;

        const imageOrigin = `${
            process.env.REACT_APP_API_URL
        }/api/containers/files/download/`;

        const logoURL =
            category.logo && category.logo.length > 0
                ? imageOrigin + category.logo[0].name
                : '';

        // console.log(category);

        return (
            <Layout>
                <Helmet>
                    <title>{`Benito Santos - ${
                        collection ? collection.title : 'México'
                    }`}</title>
                </Helmet>
                <section className="container">
                    <header className="row justify-content-center">
                        <div className="col-sm-7 col-xl-4">
                            <SectionHeader
                                logo={logoURL}
                                title="Colecciones"
                                subtitle={collection.title}
                            />
                        </div>
                    </header>
                    {collection.galleries && collection.galleries.length > 0 ? (
                        <main
                            className="container"
                            style={{ marginTop: '40px', marginBottom: '80px' }}
                        >
                            {collection.galleries.map((section, index) => {
                                const altGrid =
                                    (index + 1) % 2 === 0 ? true : false;

                                const content =
                                    index === 0 ? (
                                        <Aux>
                                            <h2>{collection.title}</h2>
                                            <p>{collection.description}</p>
                                        </Aux>
                                    ) : null;

                                const wideURL =
                                    section.wide && section.wide.length > 0
                                        ? imageOrigin + section.wide[0].name
                                        : '';

                                const tallURL =
                                    section.tall && section.tall.length > 0
                                        ? imageOrigin + section.tall[0].name
                                        : '';

                                const squared1URL =
                                    section.squared1 &&
                                    section.squared1.length > 0
                                        ? imageOrigin + section.squared1[0].name
                                        : '';

                                const squared2URL =
                                    section.squared2 &&
                                    section.squared2.length > 0
                                        ? imageOrigin + section.squared2[0].name
                                        : '';

                                return (
                                    <BSGrid
                                        key={index}
                                        wideImage={wideURL}
                                        tallImage={tallURL}
                                        squaredImage1={squared1URL}
                                        squaredImage2={squared2URL}
                                        alt={altGrid}
                                    >
                                        {content}
                                    </BSGrid>
                                );
                            })}
                        </main>
                    ) : (
                        <h2 style={styles.loadingMessage}>Cargando...</h2>
                    )}
                </section>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        menu: state.menu,
        collections: state.collections,
        categories: state.categories
    };
};

const mapDispatchToStore = dispatch => {
    return bindActionCreators(
        {
            ...menuActions,
            ...collectionsActions,
            ...categoriesActions
        },
        dispatch
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToStore
)(CollectionDetails);



// WEBPACK FOOTER //
// ./src/containers/CollectionDetails/CollectionDetails.js